var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import gql from 'graphql-tag';
export default gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment FollowedProperty on Property {\n    address {\n      id\n    }\n  }\n"])));